export function uid(prefix: string): string {
  const random = Math.random().toString(36).slice(2, 9);
  return `${prefix}_${Date.now().toString(36)}_${random}`;
}

export function stableId(prefix: string, parts: Array<string | number | undefined>): string {
  return `${prefix}_${parts
    .map((part) => String(part ?? "blank").trim().replace(/[^\w-]+/g, "_"))
    .join("_")}`;
}
